import { useState, useEffect } from "react";
import useFirebase from "../../../../../useFirebase";
import { useDispatch, useSelector } from "react-redux";
import { setShowMessage } from "../../../AxiosRtk/successMessage";
import { allowBlockCategory } from "../../../AxiosRtk/AppActivity";
// import { setRulesData } from "../../../AxiosRtk/DashBoard";

function useAppMonitoring(device, appMonitoring, setAppMonitoring) {
  const dispatch = useDispatch();
  const { selectedKidId } = useSelector(({ dashboard }) => dashboard);
  // console.log(device, appMonitoring, setAppMonitoring)
  // console.log(device)
  // const [appMonitoring, setAppMonitoring] = useState(null);
  // console.log("appMonitoring ==>>", appMonitoring)

  const {
      setRulesData
  } = useSelector(({ setRules }) => setRules);

  const { postCollectionData, getCollectionData, createCollectionData } = useFirebase();

  // useEffect(() => {
  //     if(setRulesData) {
  //         setAppMonitoring(setRulesData?.appsmonitoring)
  //     }
  // },[setRulesData])

  function callFireStore(payload) {
    if(setRulesData) {
      postCollectionData(device, payload);
    } else {
      createCollectionData(device, payload)
    }
    getCollectionData(device);
  }

  async function handleInputChange(e) {
    const { name, checked } = e.target;

    const collectionPayload = {
      ...appMonitoring,
    };
    if (name === "APP_MONITORING_ENABLE_APP_MONITORING") {
      collectionPayload["appMonitoringEnabled"] = checked;
      if (!checked) {
        collectionPayload["installNewApps"] = 0;
        collectionPayload["stopAppDeletion"] = 0;
        collectionPayload["blockOurPreselectedApp"] = 0;
        collectionPayload["ageRestrictions"] = 0;
      }
    } else if (name === "ALLOW_INSTALL_NEW_APP") {
      collectionPayload["installNewApps"] = checked ? 1 : 0;
    } else if (name === "STOP_APP_DELETION") {
      collectionPayload["stopAppDeletion"] = checked ? 1 : 0;
    } else if (name === "BLOCK_PRESELECTED_APP") {
      collectionPayload["blockOurPreselectedApp"] = checked ? 1 : 0;
    } else if (name === "AGE_RESTRICTION") {
      collectionPayload["ageRestrictions"] = checked ? 1 : 0;
    }
    // console.log({ appsmonitoring: collectionPayload })

    const newCollectionPayload = {
      setRulesActiveInActiveStatus: {...setRulesData?.setRulesActiveInActiveStatus, appMonitoringEnabled: collectionPayload['appMonitoringEnabled']},
      appsmonitoring: collectionPayload
    }

    callFireStore(newCollectionPayload);
  }

  function handleAppCategoryChange(e) {
    const { id, checked } = e.target;
    // console.log(appMonitoring, device);
    if (appMonitoring) {
      const appCategories = [...appMonitoring?.appCategory];
      const itemIndex = appCategories?.findIndex(
        (item) => parseInt(item?.id) === parseInt(id)
      );
      const itemToUpdate = { ...appCategories[itemIndex] };
      itemToUpdate["isChecked"] = checked;

      appCategories?.splice(itemIndex, 1, itemToUpdate);

      const payload = {
        ...appMonitoring,
        appCategory: appCategories,
      };
      setAppMonitoring(payload);
    }
    // console.log(e)
  }

  function handleAllSelect(e) {
    const { checked } = e.target;
    if (appMonitoring) {
      let appCategories = [...appMonitoring?.appCategory];
      appCategories = appCategories?.map((item) => {
        const tempObj = { ...item };
        tempObj["isChecked"] = checked;
        return tempObj;
      });
      // const payload = {
      //     ...appMonitoring,
      //     appCategory: appCategories
      // }
      // console.log(payload)
      setAppMonitoring(appCategories);
    }
  }

  const getStatus = (status) => {
    switch (status) {
      case "ALLOW":
        return 0;
      case "BLOCK":
        return 1;
      case "WARN":
        return 2;
    }
  };

  function handleCategoryStatusChange(item, id, status, deviceSelected) {
    let appCategories = [...appMonitoring?.appCategory];
    console.log(appCategories, id, status);

    const payload = {
      userId: selectedKidId,
      deviceId: deviceSelected,
      categoryType: "APP",
      categoryStatus: getStatus(status),
      categoryIds: [id],
      is_load_default_settings: deviceSelected,
    };

    allowBlockCategory(payload)
      .then((res) => {
        dispatch(
          setShowMessage({
            showMessage: true,
            defaultMessage: res?.data?.message,
            message: res?.data?.message,
          })
        );
      })
      .then(() => {
        if (status === "ALLOW") {
          appCategories = appCategories?.map((item) => {
            const obj = { ...item };
            if (obj?.id == id) {
              obj["categoryStatus"] = 0;
            }
            return obj;
          });
        } else if (status === "BLOCK") {
          appCategories = appCategories?.map((item) => {
            const obj = { ...item };
            if (obj?.id == id) {
              obj["categoryStatus"] = 1;
            }
            return obj;
          });
        } else if (status === "WARN") {
          appCategories = appCategories?.map((item) => {
            const obj = { ...item };
            if (obj?.id == id) {
              obj["categoryStatus"] = 2;
            }
            return obj;
          });
        }

        // console.log(appCategories)
        const collectionPayload = {
          ...appMonitoring,
          appCategory: [...appCategories],
        };

        callFireStore({ appsmonitoring: collectionPayload });
      })
      .catch((err) => {
        console.log(
          "allow block app catch error  ==>>",
          err?.response?.data?.message
        );
      });
  }

  return {
    postCollectionData,
    getCollectionData,
    handleInputChange,
    handleAppCategoryChange,
    handleAllSelect,
    handleCategoryStatusChange,
  };
}

export default useAppMonitoring;
